import { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import collabCheckListApi from "../../../api/collabCheckListApi";
import collabDocumentsApi from "../../../api/collabDocumentsApi";
import userTemplatesApi from "../../../api/userTemplatesApi";

const CopyCollabModal = ({
  show,
  onHide,
  selectedNewCollab,
  copyOption,
  setCopyOption,
}) => {
  const navigate = useNavigate();
  const collabId = selectedNewCollab?.collabId;
  const [documents, setDocuments] = useState([]);
  const [checklist, setChecklist] = useState([]);
  const user = JSON.parse(localStorage.getItem("user"));
  const userEmail = user?.userEmail;
  const userId = user?.userId;
  useEffect(() => {
    const fetchDocuments = async () => {
      try {
        const response =
          await collabDocumentsApi.getCollabDocsByCollabId(collabId);
        if (response.status === 200) {
          console.log("Documents data:", response.data);
          setDocuments(response.data);
        }
      } catch (error) {
        console.error("Error fetching documents:", error);
      }
    };
    if (collabId) fetchDocuments();
  }, [collabId]);
  useEffect(() => {
    const fetchChecklist = async () => {
      try {
        const response =
          await collabCheckListApi.getChecklistByCollabId(collabId);
        if (response.status === 200) {
          console.log("Checklist data:", response.data);
          setChecklist(response.data);
        }
      } catch (error) {
        console.error("Error fetching checklist:", error);
        alert("Failed to load checklist.");
      }
    };

    if (collabId) {
      fetchChecklist();
    }
  }, [collabId]);
  console.log(checklist);
  function base64ToFile(base64, fileName, fileType) {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: fileType });

    return new File([blob], fileName, { type: fileType });
  }
  const handleConfirm = async () => {
    if (!selectedNewCollab) return;

    if (copyOption === "copyNew") {
      navigate("/dashboard/my-collabs/new-collab", {
        state: {
          collaborationName: selectedNewCollab.collaborationName + " - Copy",
          forCompany: selectedNewCollab.forCompany,
          companyName: selectedNewCollab.companyName,
          forPerson: selectedNewCollab.forPerson,
          personName: selectedNewCollab.personName,
          cost: selectedNewCollab.cost,
          deadline: selectedNewCollab.deadline,
          checklist: checklist.map((c) => c.item),
          documents: documents.map((d) => ({
            documentName: d.documentName,
            description: d.description,
            file: d.file || null,
          })),
        },
      });
    } else if (copyOption === "template") {
      try {
        const checklistString = checklist.map((c) => c.item).join(",");

        const formData = new FormData();

        formData.append(
          "data",
          new Blob(
            [
              JSON.stringify({
                collaborationName: selectedNewCollab.collaborationName,
                description: documents?.[0]?.description || "",
                checklistItems: checklistString,
                createdBy: userEmail,
                userId: userId,
                documentName: documents?.[0]?.documentName || "document",
              }),
            ],
            { type: "application/json" },
          ),
        );

        if (documents.length > 0 && documents[0].file) {
          const fileBlob = base64ToFile(
            documents[0].file,
            documents[0].documentName,
            documents[0].fileType,
          );

          formData.append("file", fileBlob);
        }

        await userTemplatesApi.saveCollabTemplate(formData);

        Swal.fire({
          icon: "success",
          title: "Template Saved",
          text: "Collaboration copied as template successfully!",
        });
        navigate("/dashboard/templates?tab=userCollab");
      } catch (error) {
        console.error(error);
        Swal.fire({
          icon: "error",
          title: "Failed to Save Template",
          text: "An error occurred while saving the template.",
        });
      }
    }

    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Copy Collaboration {collabId}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Select how you want to copy the collaboration:{" "}
          <strong>{selectedNewCollab?.collaborationName}</strong>
        </p>
        <Form>
          <Form.Check
            type="radio"
            label="Copy and Create New Collaboration"
            name="copyOption"
            value="copyNew"
            checked={copyOption === "copyNew"}
            onChange={(e) => setCopyOption(e.target.value)}
          />
          <Form.Check
            type="radio"
            label="Copy as Template"
            name="copyOption"
            value="template"
            checked={copyOption === "template"}
            onChange={(e) => setCopyOption(e.target.value)}
          />
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleConfirm}>
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CopyCollabModal;
